import type {
  CommentType,
  Commentable,
  UserType,
} from '../components/comments/types';
import api from './api';

export const commentService = {
  async getCurrentUser(): Promise<UserType> {
    const response = await api.get<{ user: UserType }>(
      '/api/users/current_user'
    );
    return response.user;
  },

  async loadComments(
    commentable: Commentable,
    sort: string,
    page: number
  ): Promise<{ comments: CommentType[]; has_more: boolean }> {
    return api.get<{ comments: CommentType[]; has_more: boolean }>(
      '/api/comments/sort',
      {
        commentable_type: commentable.type,
        commentable_id: commentable.id,
        sort,
        page,
      }
    );
  },

  async submitComment(
    commentable: Commentable,
    body: string,
    parentId: number | null = null
  ): Promise<CommentType> {
    const response = await api.post<{ success: boolean; comment: CommentType }>(
      '/api/comments',
      {
        body,
        commentable_id: commentable.id,
        commentable_type: commentable.type,
        parent_id: parentId,
      }
    );

    if (!response.success) throw new Error('Failed to post comment');
    return response.comment;
  },

  async updateComment(commentId: number, body: string): Promise<CommentType> {
    const response = await api.put<{ success: boolean; comment: CommentType }>(
      `/api/comments/${commentId}`,
      { body }
    );

    if (!response.success) throw new Error('Failed to update comment');
    return response.comment;
  },

  async vote(
    commentId: number,
    voteType: 'upvote' | 'downvote'
  ): Promise<CommentType> {
    const response = await api.post<{ success: boolean; comment: CommentType }>(
      `/api/comments/${commentId}/${voteType}`,
      {}
    );

    if (!response.success) throw new Error(`Failed to ${voteType}`);
    return response.comment;
  },

  async deleteComment(commentId: number): Promise<void> {
    const response = await api.delete<{ success: boolean }>(
      `/api/comments/${commentId}`
    );

    if (!response.success) throw new Error('Failed to delete comment');
  },
};
